import eventTypes from 'constants/eventTypes';
import {
  PageActivityAction,
  PageActivityActions,
  PageActivityFeature,
  PageActivityLevel,
} from 'constants/pageActivityFeatures';
import trackEvent from 'utils/trackEvent';

export type PageActivityPayload = {
  feature: PageActivityFeature;
  action: PageActivityAction;
  level?: PageActivityLevel;
  societyId?: string;
  societyName?: string;
  userId?: string;
  userEmail?: string;
  userName?: string;
  userRole?: string;
  partnerId?: string;
  sectionIndex?: number;
  sectionTitle?: string;
  folderIndex?: number;
  folderTitle?: string;
  contentId?: string;
  contentTitle?: string;
  contentType?: string;
};

/** Same client shape as `useMixpanel()` for `trackEvent` */
export type PageActivityMixpanelClient = {
  config?: { token?: string };
  track: (eventName: string, properties: Record<string, unknown>) => void;
};

const resolveEventName = (action: PageActivityAction): string =>
  action === PageActivityActions.CONTENT_OPENED
    ? eventTypes.CUSTOM_LANDING_CONTENT_OPENED
    : eventTypes.CUSTOM_LANDING_VIEW;

const trackPageActivity = (
  mixpanel: PageActivityMixpanelClient | null | undefined,
  payload: PageActivityPayload
): void => {
  if (!payload?.feature || !payload?.action) return;
  if (!mixpanel?.config?.token) return;

  const eventName = resolveEventName(payload.action);
  const { feature, action, ...rest } = payload;

  trackEvent(mixpanel, eventName, { feature, action, ...rest });
};

export default trackPageActivity;
